import React, { MutableRefObject } from 'react';
import styled, { css } from 'styled-components';

export type TTextArea = {
    cols: number;
    rows: number;
    name?: string;
    wide?: boolean;
    myRef?: MutableRefObject<HTMLTextAreaElement | null>;
} & React.HTMLProps<HTMLTextAreaElement>;

const Root = styled.div<{ wide?: boolean }>`
    textarea {
        ${({ wide }) =>
            wide &&
            css`
                width: 100%;
            `};
    }
`;

const TextArea: React.FC<TTextArea> = ({
    wide = false,
    myRef,
    cols,
    rows,
    ...props
}) => {
    return (
        <Root wide={wide}>
            <textarea ref={myRef} cols={cols} rows={rows} {...props} />
        </Root>
    );
};

export default TextArea;
